import { render, staticRenderFns } from "./SavedForSecondConstructionPhaseUnblocking.vue?vue&type=template&id=48c287b6&scoped=true&"
import script from "./SavedForSecondConstructionPhaseUnblocking.vue?vue&type=script&lang=js&"
export * from "./SavedForSecondConstructionPhaseUnblocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c287b6",
  null
  
)

export default component.exports